import { IdType } from 'react-table';

/** Настройки постраничного вывода запроса DataQuery */
export type DataQueryPaging = {
  top: number;
  skip: number;
  count: boolean;
  pageIndex: number;
};

/** Результат выполнения запроса DataQuery */
export interface DataQueryResult<T, TAdditionalInfo = undefined> {
  items: T[];
  totalCount?: number;
  additionalInfo?: TAdditionalInfo;
}

export enum SortingDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}

export interface DataQuerySortingItem<TSorting> {
  propName: TSorting;
  direction: SortingDirection;
}

export type DataQuerySorting<TSorting> = DataQuerySortingItem<TSorting>[];

export type DataQuerySelection = {
  highlightedRowId?: IdType<string> | undefined;
};

/** Запрос DataQuery */
export type DataQuery<TFilter, TSorting> = {
  paging: DataQueryPaging | undefined;
  filter: TFilter | undefined;
  sorting: DataQuerySorting<TSorting> | undefined;
  selection: DataQuerySelection | undefined;
};
